import { render, staticRenderFns } from "./HierarchicalAllocation.vue?vue&type=template&id=77c820fb&scoped=true"
import script from "./HierarchicalAllocation.vue?vue&type=script&lang=js"
export * from "./HierarchicalAllocation.vue?vue&type=script&lang=js"
import style0 from "./HierarchicalAllocation.vue?vue&type=style&index=0&id=77c820fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c820fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77c820fb')) {
      api.createRecord('77c820fb', component.options)
    } else {
      api.reload('77c820fb', component.options)
    }
    module.hot.accept("./HierarchicalAllocation.vue?vue&type=template&id=77c820fb&scoped=true", function () {
      api.rerender('77c820fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hierarchicalCommissionAllocation/RankCommission/components/HierarchicalAllocation.vue"
export default component.exports